import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PfiService } from '../../mock/pfi.service';

@Component({
  selector: 'app-pfi-dropdown',
  templateUrl: './pfi-dropdown.component.html',
  styleUrls: ['./pfi-dropdown.component.scss']
})
export class PfiDropdownComponent implements OnInit {

  @Output() onPfiChange: EventEmitter<any> = new EventEmitter();
  @Input() set initialProformaId(id: number | string | null) {
    if (id != null && !this.selectedPfi) {
      this.selectedPfi = {proformaId: id};
    }
  }
  public isLoading: boolean = false;

  public pfiList: any[];
  selectedPfi: any;
  constructor(private pfiService: PfiService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.pfiService.getPfiValueSheets().subscribe((data) => {
      this.pfiList = data;
      this.isLoading = false;
    });
  }

  refreshPfiData(): void {
    this.isLoading = true;
    this.pfiService.refreshCache().subscribe({
      next: (data) => {
        this.pfiList = data;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  public pfiCompareFn(a: any, b: any) {
    return a && b ? a.proformaId === b.proformaId : a === b;
  }

    public getPfiLabel(pfi: any): string {
      const accountNo = pfi?.accountNo ?? pfi?.modelClient?.accountNo ?? 'No account number';
      const pfiNo = pfi?.proformaId ?? pfi?.pfiId ?? 'No PFI number';

      return `${accountNo} - ${pfiNo}`;
    }

}


